import { useQuery } from 'react-query'
import { useReadingGoals } from '../ctx/reading_goals'
import { useStats } from '../ctx/stats'
import { useStatsPermission } from './useStatsPermission'
import { useSearchParams } from 'react-router-dom'
import { registerFableScript } from 'app/webview/utils'
import { ReadingGoalPeriodType } from '../types'

export const useLoadReadingGoals = () => {
  const [isSelfView, year, yearStatus] = useStats((s) => [
    s.isSelfView,
    s.year,
    s.yearStatus,
  ])
  const { isAndroid, isPlusUser } = useStatsPermission()
  const [statsUserId, getReadingGoals] = useReadingGoals((s) => [
    s.statsUserId,
    s.getReadingGoals,
  ])
  const [searchParams] = useSearchParams()
  const hasPeriodTypeParam = searchParams.has('period_type')
  const isPrior2025 = year < 2025
  const checkAll =
    !isPrior2025 &&
    !isAndroid &&
    isSelfView &&
    isPlusUser &&
    !hasPeriodTypeParam
  const isFreeViewingOther = !isSelfView && !isPlusUser
  const yearOnly = isFreeViewingOther || isPrior2025 || isAndroid
  const goalPeriod =
    (searchParams.get('period_type') as ReadingGoalPeriodType) || 'year'

  const query = useQuery(
    ['reading-goal', statsUserId],
    async () =>
      await getReadingGoals({
        period: goalPeriod,
        checkAll,
        year: yearOnly ? year : undefined,
        fetchSuggestions: yearStatus === 'current' && isSelfView && !isAndroid,
      }),
    {
      enabled: !!statsUserId && !!year,
      refetchOnMount: true,
      staleTime: 0,
      cacheTime: 0,
    }
  )

  registerFableScript('refreshGoals', query.refetch)
}
